import type { InformationBanner } from '@brighterly/lib-core-types/ui/notifications/interfaces'

import { useCommonStore } from '@stores/common'

import { useCsRoutes } from '@composables/routes/cs-route.hook'

export const useInformationBannerApi = async (): Promise<InformationBanner> => {
  const { $axios } = useNuxtApp()
  const commonStore = useCommonStore()

  const url = useCsRoutes('information-banner')
  const { data } = await $axios.get(url!)

  const informationBanner: InformationBanner = data.data || {
    information_banner_is_demo: false,
    information_banner_is_paid: false,
    information_banner_text: '',
    information_banner_title: '',
  }

  commonStore.setInformationBanner(informationBanner)

  return informationBanner
}
